var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline-flex ml-1 cursor-pointer",attrs:{"title":"Vlieg naar dit adres"}},[_c('SvgIcon',{attrs:{"icon":"crosshairs-solid"},nativeOn:{"click":function($event){return _vm.flyTo.apply(null, arguments)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }